<div [ngClass]="{ 'ap-opacity-6 pe-none': !isUpsertFormSecurityEnabled() }">
  <div class="ap-p-spacing-6">
    <div class="ap-typography-heading-m">
      {{ securityTitle }}
    </div>
  </div>

  <gstar-security-form
    [upsertSecurityState]="state"
    [generalRateRule]="null"
    (addSecurity)="handleSuccessAdded($event)"
    (updatedSecurity)="handleSuccessfulUpdate()" />
</div>
